// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox_Checkbox__1KW_y","validator":"Checkbox_validator__ZOUqR","default":"Checkbox_default__PERS8","small":"Checkbox_small__3V39m"};